export const productMixin = {
    methods: {
        pushChangeToArray: function(receivingArray, niceName, key, oldNiceValue, newNiceValue, oldValue, newValue, allowRepetitions) {
            // debugger
            //default arguments
            allowRepetitions = (typeof allowRepetitions !== 'undefined') ? allowRepetitions : false;

            //check if item already exists on array
            let foundRepetition = key != null? receivingArray.find(i => i.name == key) : true

            if(allowRepetitions == false && foundRepetition){
                let repetitionIndex = receivingArray.indexOf(foundRepetition)
                receivingArray[repetitionIndex] = {
                    name: key,
                    niceName: niceName,
                    oldNiceValue: oldNiceValue,
                    newNiceValue: newNiceValue,
                    oldValue: oldValue,
                    newValue: newValue
                }
            } else {
                receivingArray.push({
                    name: key,
                    niceName: niceName,
                    oldNiceValue: oldNiceValue,
                    newNiceValue: newNiceValue,
                    oldValue: oldValue,
                    newValue: newValue
                })
            }
        },
    },
}



// WEBPACK FOOTER //
// ./src/mixins/product.js